import { Component } from '@angular/core';
import { ContactDetailModel } from '../../../../../../shared/store/contact/types';
import { Observable } from 'rxjs';
import { ContactService } from '../../../../../../shared/store/contact/contact.service';

@Component({
  selector: 'app-contact-details-insurance-claims',
  standalone: false,
  templateUrl: './contact-details-insurance-claims.component.html',
  styleUrl: './contact-details-insurance-claims.component.scss',
})
export class ContactDetailsInsuranceClaimsComponent {
  contactDetail$: Observable<ContactDetailModel>;

  constructor(private readonly contactService: ContactService) {
    this.contactDetail$ = this.contactService.getById.value$;
  }
}
